import styled from 'styled-components'

export const StyledType = styled.div`
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  padding: 0 6px;
  font-weight: 500;
  border-radius: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  color: var(--tt-fg-light);
  background-color: var(--tt-bg);

  html[data-theme='dark'] & {
    color: var(--tt-fg-dark);
    background-color: var(--p-neutral-700);
  }

  html[data-theme='dark'] &[data-variant='template'] {
    background-color: var(--p-neutral-690);
  }
`
